import { render, staticRenderFns } from "./GreenPremiseForm.vue?vue&type=template&id=1a351e31&scoped=true&"
import script from "./GreenPremiseForm.vue?vue&type=script&lang=js&"
export * from "./GreenPremiseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a351e31",
  null
  
)

export default component.exports